
























































































import Vue, { PropOptions } from 'vue';
// import NOC from '@/const/index' ;
// import SideModalBase from '@/components/util/SideModalBase.vue';
import SearchBox from '@/components/util/SearchBox.vue';
import BasicGadget, {VUECHARTGRAPH, IGraph, CFrame} from '@/components/gadgets/BasicGadget.vue';
import * as models from '@/class/models/views/graph';
import Gadgets from '@/components/gadgets';


const MODE_LIST = 'list';
const MODE_CARD = 'card';
const MODE_DETAIL = 'detail';

const LIST_MODE_KOJIN = 'kojin';
const LIST_MODE_DEFAULT = 'default';

export interface ISettings {
  edit: boolean;
  add: boolean;
  tab: boolean;
}

export class CSettings implements ISettings {
  public edit = false;
  public add  = false;
  public tab = false;
}

export default Vue.extend({
  name: 'GadgetList',
  components: {
    SearchBox, BasicGadget,
  },
  props: {
    gadgets: Array as PropOptions<models.IGadget[]>,
    settings: {
      type: Object as () => ISettings,
      default: () => new CSettings(),
    },
    addGadgetLock: Boolean,
  },
  data() {
    return {
      title: 'a',
      mode: MODE_CARD,
      searchValue: '',
      selectGadget: {},
      dispTarget: LIST_MODE_KOJIN,
      componentGadgets: Gadgets,
      frameData: new CFrame(),
      isActive: 'tab-1',
      selectCardNum: '',
      selectedX: 0,
      selectedY: 0,
      positionSet: '',
      isTaller: false,
      titleList: [
        {
          id: 'sample',
          title: 'サンプルグラフ',
          open: false,
          active: 'tab-1',
        },
        {
          id: 'kojin',
          title: '作成グラフ',
          open: false,
          active: 'tab-2',
        },
      ],
    };
  },
  computed: {
    MODE_LIST(): string { return MODE_LIST; },
    MODE_CARD(): string { return MODE_CARD; },
    MODE_DETAIL(): string { return MODE_DETAIL; },
    // DISP_LIST(): models.IGadget[] {
    DISP_LIST() {
      const gadgets: models.IGadget[] = this.gadgets.filter((v) => (v.title.indexOf(this.searchValue) >= 0));
      const returnGadgets = {
        sample: gadgets.filter((v) => (v.default)),
        kojin: gadgets.filter((v) => (!v.default)),
        share: [],
      };
      // console.log(this.tab);
      return returnGadgets;
    },
    filteredtab() {
      // @ts-ignore
      return this.titleList.filter((title: any) => (this.isActive === title.active));
    },
  },
  watch: {
    gadgets() {
      this.changeShow('kojin');
    },
  },
  mounted() {
    // this.frameData.show = false;
    // this.frameData.cover = true;
    this.frameData.icontooltip = false; // v3ガジェット用
  },
  methods: {
    changeShow(mode: string) {
      this.mode = MODE_LIST;
      this.dispTarget = mode;
    },
    onClickAddEvent() {
      // this.$emit('add', this.selectIndex);
    },
    onClickShowGadgetEditer() {
      this.$emit('edit', new models.CGadget());
    },
    onClickGadget(select: any) {
      this.mode = MODE_DETAIL;
      this.selectGadget = select;
      (document.getElementById('gadget_list_menu')!).scrollTo(0, 0);
      if (select.default) {
        this.$data.dispTarget = LIST_MODE_DEFAULT;
      } else {
        this.$data.dispTarget = LIST_MODE_KOJIN;
      }
    },
    onClickGadgetEdit() {
      this.$emit('edit', this.selectGadget);
      this.$emit('close');
    },
    onClickGadgetAdd() {
      this.$emit('add', this.selectGadget);
      this.$emit('close');
    },
    onDragStartGadget(gadget: models.IGadget) {
      this.$emit('holding', gadget);
    },
    onDragEndGadget() {
      this.$emit('holding', {});
    },
    getIcon(gadget: models.IGadget): string {
      // console.log(gadget);
      let src = '';
      switch (gadget.gadget) {
        case 'BasicGadget':
        case 'SampleGadget':
          for (const graph of VUECHARTGRAPH) {
            if (graph.key === gadget.data.graph[0].key) {
              src = graph.src;
            }
          }
          break;
        case 'CSVDLGadget':
          src = `\\images\\gadgets\\${gadget.gadget}3.png`;
          break;
      }
      return src;
    },
    change(num: any) {
      this.isActive = num;
    },
    selectCard(key: any) {
      this.selectCardNum = key;
    },
    // アクティブなカードの位置取得
    selectedPosition(key: any) {
      const testRef: any = this.$refs['positionSet_' + key];
      // console.dir(testRef[0]);
      this.selectedX = testRef[0].getBoundingClientRect().left;
      this.selectedY = testRef[0].getBoundingClientRect().top;
      if (window.innerHeight - testRef[0].getBoundingClientRect().bottom <= 316) {
        // this.selectedY = (window.innerHeight - 675);
        this.isTaller = true;
      } else {
        this.isTaller = false;
      }
    },
  },
});

